import { Footer } from "../../../MarketingSiteComponents/Footer";

const RefundPolicy = () => {
    return (
        <>
            <p>&nbsp;</p>

            <div style={{ textAlign: 'left', margin: '10px 1px', fontFamily: 'poppins', minHeight: '65vh' }} className="container mx-auto p-6 text-gray-800">
                <strong style={{ fontSize: '3vh' }}>Refund Policy</strong><br />
                <p>&nbsp;</p>

                <p>We do our best to bring excellent courses at your comfort and we want to make sure you have the best learning experience on {window.location.origin === 'https://www.medineer.ai' ? 'MEDINEER.AI' : 'learnerFitbit'}. However, sometimes a course might just not be right for you. That's exactly why we dont show you a fancy marketing video and get you to pay. </p>
                <p>&nbsp;</p>
                <p>Given that <strong> {window.location.origin === 'https://www.medineer.ai' ? 'MEDINEER.AI' : 'learnerFitbit'} </strong> provides orchestration platform for the courses, it isnt feasible for us to offer a refund in case you arent happy with it. Nonetheless, if you still have concerns or issues, please raise them to us via email at <a href="mailto:support@splayndid.com">support@splayndid.com</a> and we'll do what's best possible! </p>
                <p>&nbsp;</p>

            </div>
            <Footer />
        </>

    );
};

export default RefundPolicy;
